import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from "../hooks/useAuth";

interface AuthRouteProps {
  redirectPath?: string;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ redirectPath = '/' }) => {
    const { isAuthenticated } = useAuth();
    if (isAuthenticated) {
        console.log('[DEBUG] User is authenticated redirecting to ' + redirectPath);
        return <Navigate to={redirectPath} />;
    }
    return <Outlet />;
};

export default AuthRoute;